var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "projectCard" },
    [
      _vm.project
        ? _c("PageHeadContainer", {
            staticClass: "customMinHeight customPadding",
            attrs: { heightStyle: "minHeight", title: _vm.project.client_name },
            scopedSlots: _vm._u(
              [
                {
                  key: "status",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "flex mb-4 sm:mb-3" },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-storm-gray text-base font-medium leading-normal",
                            },
                            [_vm._v(" " + _vm._s(_vm.age) + " ")]
                          ),
                          _c("span", { staticClass: "line text-center" }, [
                            _vm._v("|"),
                          ]),
                          _vm.gender
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "text-storm-gray text-base font-medium leading-normal",
                                },
                                [_vm._v(" " + _vm._s(_vm.gender) + " ")]
                              )
                            : _c(
                                "p",
                                {
                                  staticClass:
                                    "text-storm-gray text-base font-medium leading-normal",
                                },
                                [_vm._v(" n/a ")]
                              ),
                          _vm.projectCompleted
                            ? _c("CardInfoChip", {
                                staticClass: "ml-2",
                                attrs: { message: "closed" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "mb-4 flex flex-row sm:hidden" },
                        [
                          _c("LocationIcon", {
                            staticClass: "h-4 w-4 mr-2.5 iconStyle",
                          }),
                          _vm.location
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "text-blue text-sm font-normal hover:underline leading-4",
                                  attrs: {
                                    href: _vm.googleMapsLink,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.location) + " ")]
                              )
                            : _c(
                                "p",
                                {
                                  staticClass: "text-blue text-sm font-normal",
                                },
                                [_vm._v("n/a")]
                              ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "avatar",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex sm:flex-row flex-col-reverse justify-between items-end sm:items-center",
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-gray-new font-normal mr-auto sm:mr-0 text-xs sm:text-sm leading-4 sm:leading-5 mb-3 sm:mb-1 mt-4 sm:mt-1",
                            },
                            [_vm._v(" " + _vm._s(_vm.createdAt) + " ")]
                          ),
                          _c("div", [
                            _vm.projectCompleted
                              ? _c(
                                  "div",
                                  { staticClass: "flex ml-auto" },
                                  [
                                    _c("UiButton", {
                                      staticClass: "mx-2",
                                      attrs: {
                                        processing: _vm.statusProcessing,
                                        buttonText: "Reopen",
                                        variant: "outline-black",
                                        buttonClasses:
                                          "px-2 pr-5 pl-3.5 customHeight",
                                        size: "md",
                                      },
                                      on: { click: _vm.reopenProject },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "icon",
                                            fn: function () {
                                              return [
                                                _c("ReopenIconBlack", {
                                                  staticClass: "w-6 h-6",
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "hover-icon",
                                            fn: function () {
                                              return [
                                                _c("ReopenIconBlack", {
                                                  staticClass: "w-6 h-6",
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        1680552354
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  { staticClass: "flex ml-auto" },
                                  [
                                    _c("UiButton", {
                                      staticClass: "mx-2",
                                      attrs: {
                                        buttonText: "Edit",
                                        variant: "outline-black",
                                        buttonClasses:
                                          "px-2 pr-4 pl-4 customHeight",
                                        size: "md",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit("edit")
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "icon",
                                            fn: function () {
                                              return [
                                                _c("EditIcon", {
                                                  staticClass: "w-4 h-4",
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "hover-icon",
                                            fn: function () {
                                              return [
                                                _c("EditIcon", {
                                                  staticClass: "w-6 h-6",
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        36319490
                                      ),
                                    }),
                                    _c("UiButton", {
                                      attrs: {
                                        buttonText: "Mark profile closed",
                                        buttonClasses:
                                          "px-2 pr-4 pl-4 customHeight",
                                        variant: "black",
                                      },
                                      on: { click: _vm.completeProject },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "icon",
                                            fn: function () {
                                              return [
                                                _c("CompleteIcon", {
                                                  staticClass: "w-4 h-4",
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "hover-icon",
                                            fn: function () {
                                              return [
                                                _c("CheckMarkBlack", {
                                                  staticClass: "w-6 h-6",
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        290038420
                                      ),
                                    }),
                                    _vm.dialog
                                      ? _c("CompleteModal", {
                                          on: {
                                            updateProjectStatus:
                                              _vm.refetchProject,
                                            close: _vm.closeModal,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "icons",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "flex flex-row mb-1.5 sm:mb-1" },
                        [
                          _c("UserIcon", { staticClass: "mr-2" }),
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-sm sm:text-base text-primary-black customLineHet font-semibold mr-0.5",
                            },
                            [_vm._v(" Client ID: ")]
                          ),
                          _c("p", { staticClass: "details" }, [
                            _vm._v(_vm._s(_vm.clientId)),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex flex-row mb-4 items-center" },
                        [
                          _c("StarIcon", { staticClass: "mr-2" }),
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-sm sm:text-base text-primary-black customLineHet font-semibold mr-0.5",
                            },
                            [_vm._v(" Type of work: ")]
                          ),
                          _c("p", { staticClass: "details" }, [
                            _vm._v(_vm._s(_vm.typeOfWork)),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "flex flex-col mb-4" }, [
                        _c(
                          "div",
                          { staticClass: "flex flex-row items-center" },
                          [
                            _c("ContactIcon", { staticClass: "mr-2" }),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-sm sm:text-base text-primary-black customLineHet font-semibold",
                              },
                              [_vm._v(" Contact: ")]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "flex flex-row mb-1 gap-3" }, [
                          _c("p", { staticClass: "details" }, [
                            _vm._v("Primary: " + _vm._s(_vm.primaryContact)),
                          ]),
                        ]),
                        _c("p", { staticClass: "details" }, [
                          _vm._v("Email: " + _vm._s(_vm.emailAddress)),
                        ]),
                      ]),
                      _vm.emergencyRelation ||
                      _vm.emergencyName ||
                      _vm.emergencyContact ||
                      _vm.emergencyEmail
                        ? _c("div", { staticClass: "flex flex-col mb-4" }, [
                            _c(
                              "div",
                              { staticClass: "flex flex-row items-center" },
                              [
                                _c("ContactIcon", { staticClass: "mr-2" }),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-sm sm:text-base text-primary-black customLineHet font-semibold",
                                  },
                                  [_vm._v(" Emergency contact: ")]
                                ),
                              ],
                              1
                            ),
                            _vm.emergencyRelation || _vm.emergencyName
                              ? _c(
                                  "div",
                                  { staticClass: "flex flex-row mb-1 gap-3" },
                                  [
                                    _vm.emergencyRelation
                                      ? _c("p", { staticClass: "details" }, [
                                          _vm._v(
                                            " Relation: " +
                                              _vm._s(_vm.emergencyRelation) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.emergencyName
                                      ? _c("p", { staticClass: "details" }, [
                                          _vm._v(
                                            " Name: " +
                                              _vm._s(_vm.emergencyName) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                            _vm.emergencyContact || _vm.emergencyEmail
                              ? _c(
                                  "div",
                                  { staticClass: "flex flex-row gap-3" },
                                  [
                                    _vm.emergencyContact
                                      ? _c("p", { staticClass: "details" }, [
                                          _vm._v(
                                            " Primary: " +
                                              _vm._s(_vm.emergencyContact) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.emergencyEmail
                                      ? _c("p", { staticClass: "details" }, [
                                          _vm._v(
                                            " Email: " +
                                              _vm._s(_vm.emergencyEmail) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _c("div", [
                            _c(
                              "div",
                              { staticClass: "flex flex-row items-center" },
                              [
                                _c("ContactIcon", { staticClass: "mr-2" }),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-sm sm:text-base text-primary-black customLineHet font-semibold",
                                  },
                                  [_vm._v(" Emergency contact: ")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "flex flex-row mb-1 gap-3" },
                              [
                                _c("p", { staticClass: "details" }, [
                                  _vm._v("No emergency contact added"),
                                ]),
                              ]
                            ),
                          ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "location",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "hidden sm:flex flex-row gap-2 customMargin",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col",
                              staticStyle: { width: "234px" },
                            },
                            [
                              _vm.location !== "n/a"
                                ? _c("LocationImage", {
                                    attrs: { location: _vm.location },
                                  })
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "mx-1 my-2 flex flex-row" },
                                [
                                  _c("LocationIcon", {
                                    staticClass: "h-4 w-4 mr-2.5 iconStyle",
                                  }),
                                  _vm.location
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-blue text-base font-normal hover:underline customLineHet",
                                          attrs: {
                                            href: _vm.googleMapsLink,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.location) + " "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-blue text-sm font-normal",
                                        },
                                        [_vm._v("n/a")]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "bottom",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col sm:flex-row gap-3 sm:gap-10 mediumMinHeight",
                        },
                        [
                          _c("div", { staticClass: "desktopWidth" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-primary-black font-medium text-sm sm:text-base customLineHet mb-2 sm:mb-4",
                              },
                              [_vm._v(" Manager ")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "flex flex-row gap-2 items-center",
                              },
                              [
                                _vm.managerLink
                                  ? _c(
                                      "RouterLink",
                                      { attrs: { to: _vm.managerLink } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-nav-gray text-sm font-medium rounded-full block border border-gray-300 bg-white borderCard hover:text-primary-500 hover:border-primary-500 items-center overflow-hidden",
                                          },
                                          [
                                            _vm.project.manager.user
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex flex-row items-center",
                                                    attrs: {
                                                      name: "imageAvatar",
                                                      image:
                                                        _vm.project.manager.user
                                                          .avatar,
                                                    },
                                                  },
                                                  [
                                                    _vm.project.manager.user
                                                      .avatar !== null
                                                      ? _c("S3Image", {
                                                          class: [
                                                            _vm.defaultImageClasses,
                                                          ],
                                                          attrs: {
                                                            s3FileKey:
                                                              _vm.project
                                                                ?.manager?.user
                                                                ?.avatar,
                                                          },
                                                        })
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-xs leading-none font-medium mr-1",
                                                            class:
                                                              _vm.getAvatarClass,
                                                            style: _vm.bgStyle,
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.initial
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-storm-gray chipText font-normal",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.project
                                                                .manager.user
                                                                .given_name
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.project
                                                                .manager.user
                                                                .family_name
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-normal text-base text-storm-gray flex items-center",
                                      },
                                      [_vm._v(" n/a ")]
                                    ),
                                _vm.managerLink
                                  ? _c(
                                      "button",
                                      {
                                        on: {
                                          click: _vm.message,
                                          mouseover: function ($event) {
                                            _vm.isHoveredChat = true
                                          },
                                          mouseout: function ($event) {
                                            _vm.isHoveredChat = false
                                          },
                                        },
                                      },
                                      [
                                        !_vm.isHoveredChat
                                          ? _c("ChatIcon", {
                                              staticClass: "h-7 w-7",
                                            })
                                          : _vm._e(),
                                        _vm.isHoveredChat
                                          ? _c("ChatIcon", {
                                              staticClass: "h-7 w-7",
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "desktopWidth" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col w-full skills-footer items-left",
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-primary-black font-medium text-sm sm:text-base customLineHet mb-2 sm:mb-4",
                                  },
                                  [_vm._v(" Tags ")]
                                ),
                                _vm.uniqueSkills?.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-row gap-1 items-center",
                                      },
                                      [
                                        _vm._l(
                                          _vm.uniqueSkills?.slice(0, 3),
                                          function (skill) {
                                            return _c(
                                              "div",
                                              {
                                                key: skill.skill.name,
                                                staticClass: "skills-chip",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(skill.skill.name) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        _vm.uniqueSkills?.length > 3
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cursor-default hover:!cursor-pointer",
                                              },
                                              [
                                                _c(
                                                  "RouterLink",
                                                  {
                                                    attrs: {
                                                      to: _vm.detailsPageRoute,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "skills-chip-plus",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " +" +
                                                            _vm._s(
                                                              _vm.uniqueSkills
                                                                ?.length - 3
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm.uniqueSkills?.length === 0 ||
                                _vm.uniqueSkills === undefined
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center text-base",
                                      },
                                      [_vm._v(" n/a ")]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "flex flex-col desktopWidth" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-primary-black font-medium text-sm sm:text-base customLineHet mb-2 sm:mb-4",
                                },
                                [_vm._v(" Resource cost to date ")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-storm-gray text-base customLineHet",
                                },
                                [
                                  _vm._v(
                                    " $" + _vm._s(_vm.resourceCostDate) + " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2120356522
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }